import { Link } from 'react-router-dom'
import styled from 'styled-components'

import Button from 'atoms/Button'
import Typography from 'atoms/Typography'
import CustomSelect from 'atoms/CustomSelect'

export const StyledRoot = styled.div`
  max-width: 100%;
  margin: 0 auto 150px;
  position: relative;

  @media (min-width: 992px) {
    max-width: 70%;
  }
  @media (max-width: 992px) {
    margin: 0 auto 25px;
  }
`

export const StyledTypography = styled(Typography)`
  margin: 0 auto;
  font-size: 1.25rem;
  @media (max-width: 768px) {
    font-size: 1.25rem;
  }
`

export const StyledSection = styled.section<{ mgTop?: number }>`
  padding: 24px 24px 48px;
  background-color: #f8f9fa;
  border: 1px solid #ced4da;
  margin-top: 28px;
`

export const StyledFormControl = styled.div`
  display: grid;
  grid-auto-flow: row;
  grid-auto-rows: max-content;
  grid-gap: 28px;
`

export const StyledLink = styled(Link)`
  color: #19b3ff;
  margin-top: 15px;
  display: inline-block;

  &:hover {
    opacity: 0.8;
  }
`

export const StyledMandatory = styled.span`
  color: red;
`

export const StyledWeeks = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`

export const StyledButton = styled(Button)`
  padding: 10px 30px;
  width: 98px;
  max-width: 98px;
  box-sizing: border-box;

  &:hover {
    opacity: 0.9;
  }
`

export const StyledCustomSelect = styled(CustomSelect)`
  background-color: #fff;
`

export const StyledButtonContainer = styled.div`
  display: flex;
  justify-content: right;
  margin-top: 44px;
`

export const StyledCalculateButton = styled(Button)`
  padding: 7px 13px;
  background: #19b3ff;
  border-radius: 4px;

  &:hover {
    opacity: 0.8;
  }
`

export const StyledGroupContainer = styled.div`
  width: 40%;
  @media (max-width: 768px) {
    width: 100%;
  }
`

export const StyledInnerFormContainer = styled.div`
  display: grid;
  grid-auto-flow: row;
  grid-auto-rows: max-content;
  grid-row-gap: 10px;
`
